/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseData } from './FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseData';
import {
    instanceOfFxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseData,
    FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseDataFromJSON,
    FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseDataFromJSONTyped,
    FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseDataToJSON,
} from './FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseData';

/**
 * @type FxIdApplicationHandlersAuthConnectTwitchAccountHandlerConnectTwitchAccountHandlerResponseData
 * 
 * @export
 */
export type FxIdApplicationHandlersAuthConnectTwitchAccountHandlerConnectTwitchAccountHandlerResponseData = FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseData;

export function FxIdApplicationHandlersAuthConnectTwitchAccountHandlerConnectTwitchAccountHandlerResponseDataFromJSON(json: any): FxIdApplicationHandlersAuthConnectTwitchAccountHandlerConnectTwitchAccountHandlerResponseData {
    return FxIdApplicationHandlersAuthConnectTwitchAccountHandlerConnectTwitchAccountHandlerResponseDataFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthConnectTwitchAccountHandlerConnectTwitchAccountHandlerResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersAuthConnectTwitchAccountHandlerConnectTwitchAccountHandlerResponseData {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseData(json)) {
        return FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseDataFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationHandlersAuthConnectTwitchAccountHandlerConnectTwitchAccountHandlerResponseDataToJSON(json: any): any {
    return FxIdApplicationHandlersAuthConnectTwitchAccountHandlerConnectTwitchAccountHandlerResponseDataToJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthConnectTwitchAccountHandlerConnectTwitchAccountHandlerResponseDataToJSONTyped(value?: FxIdApplicationHandlersAuthConnectTwitchAccountHandlerConnectTwitchAccountHandlerResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseData(value)) {
        return FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseDataToJSON(value as FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseData);
    }

    return {};
}

